import React, { useCallback, useEffect, useRef, useState } from "react";

import Table from "../../components/table/Table";

import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../components/common/Input/Input";
import { Controller, useForm } from "react-hook-form";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment";
import { debounce, values } from "lodash";
import axios from "axios";
import { toast } from "react-toastify";
import CustomSelect from "../../components/common/Select/Select";

const Blog = () => {
  const { doLogin, currUserData } = useAuthContext();
  const [popupShow, setPopupShow] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState("");
  const imageRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(1);
  const [image, setImage] = useState("");
  const [inputKeys, setInputKeys] = useState({});
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const blogTypeData = [
    { label: "Blog", value: 1 },
    { label: "Article", value: 2 },
  ];
  const blogType = blogTypeData.map((item) => ({
    label: item.label, // Show "name" in dropdown
    value: item.value, // Return "_id" on select
  }));

  console.log(blogType, "blogType");

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const handleEdit = async (original) => {
    console.log(original, "jdjdj");
    setPopupShow(true);

    setEditData(original);
    const fields = ["title", "content", "phone"];

    fields.forEach((field) => setValue(field, original[field]));
    setImage(original?.image);

    // Find the matching gender option

    const selectedType = blogTypeData.find(
      (opt) => opt.value === original?.type
    );

    setValue("type", selectedType);
  };
  const DeleteBlog = async (id) => {
    const res = await api(
      `api/v1/blog/${id}`,
      {},
      "delete",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      getBlogData();
    }
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      //   getBlogData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const registerOptions = {
    title: { required: "Title is required" },
    content: { required: "Content is required" },
  };
  const AddBlog = async (data) => {
    console.log(data?.type?.value, "form sdf");
    setEditData("");

    var payload = {
      title: data.title,
      image: image,
      type: data?.type?.value,

      ...(data.url && { url: data.url }),
      content: data.content,
    };
    const editPayload = {
      title: data.title,
      image: image,
      type: data?.type?.value,

      //   ...(data.url && { url: data.url }),
      content: data.content,
    };
    if (editData) {
      let res = await api(
        `api/v1/blog/${editData._id}`,
        editPayload,
        "put",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setPopupShow(false);
        reset();
        getBlogData();
      }
    } else {
      let res = await api(
        `api/v1/blog/create`,
        payload,
        "post",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setPopupShow(false);
        reset();
        getBlogData();
      }
    }
  };

  const getBlogData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/blog?page=${pageIndex + 1}&limit=${pageSize}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.data);
      setIsLoading(false);
      setTotalCount(res?.pagination.totalItems);
    }
  };

  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const columns = React.useMemo(
    () => [
      
        
      
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ row }) =>
          row.original.type === 1 ? "Blog" : row.original.type === 2 ? "Article" : ""

      },
      {
        Header: "Author Name",
        accessor: "author.name",
      },
      {
        Header: "Email ID",
        accessor: "author.email",
      },

      //   {
      //     Header: "Status",
      //     accessor: "status",
      //     Cell: ({ row }) => (
      //       <div class="form-check form-switch">
      //         <input
      //           onChange={() => handleToggleStatus(row.index)}
      //           className="form-check-input"
      //           type="checkbox"
      //           id="mySwitch"
      //           name="darkmode"
      //           value="yes"
      //           checked={row.original.status === 1 ? true : false}
      //         />
      //       </div>
      //     ),
      //   },
      {
        Header: "Created On",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.uploadDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div class="dropdown">
            <span
              data-bs-toggle="dropdown"
              style={{ cursor: "pointer" }}
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </span>
            <ul class="dropdown-menu">
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleEdit(row.original);
                  }}
                >
                  Edit
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => DeleteBlog(row.original._id)}
                >
                  Delete
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  const handleFileUpload = async (event, type, moduleIndex, fileIndex) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/course/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${currUserData?.token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / (progressEvent.total || 1)
            );
            setUploadProgress(percentCompleted);
          },
        }
      );

      if (response && response.data) {
        toast.success("Image uploaded ");
        const data = response.data.data.url;

        setImage(data);
      } else {
        toast.error("File not uploaded ");
        imageRef.current.value = "";
      }
    } catch (error) {
      toast.error("File not uploaded please retry");
      imageRef.current.value = "";
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    getBlogData();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="blog_management">
        <div className="p-40">
          <div className="page_heading mb-4">
            <div>
              <p className="heading">Blogs</p>
            </div>

            <button
              className="btn_primary"
              onClick={() => {
                setPopupShow(!popupShow);
                setEditData("");
                setImage("");
                reset();
              }}
            >
              + Add Blog
            </button>
          </div>

          <div className="blog_list ">
            <Table
              columns={columns}
              data={data}
              onToggleStatus={handleToggleStatus}
              onSearch={handelSearch}
              isLoading={isLoading}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              setPageIndex={setPageIndex}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>

      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        closeIcon={true}
        id="Add Blog"
        // title="Add Blog"
        title={editData ? "Edit Blog" : "Add Blog"}
        bg={false}
        width="lg"
      >
        <form className="w-100  p-5" onSubmit={handleSubmit(AddBlog)}>
          <Row>
            <Col md="6">
              <CustomInput
                register={register}
                label="Title"
                name="title"
                placeholder="e.g., Title"
                type={"text"}
                errors={errors.title}
                validation={registerOptions.title}
              />
            </Col>
            <Col md="6">
              <CustomInput
                register={register}
                label="Url"
                name="url"
                placeholder="e.g., calsshila.com"
                type={"text"}
                errors={errors.url}
                validation={registerOptions.url}
              />
            </Col>
            <div className="col-6">
              <div className="form_group w-100">
                <label className="input_lable">Image</label>

                <div
                  className="custom_input file-upload-container"
                  style={{ position: "relative" }}
                >
                  <input
                    type="file"
                    ref={imageRef}
                    accept="image/*"
                    onChange={handleFileUpload}
                    className="file-upload-input"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                    }}
                  />

                  <input
                    type="text"
                    value={image || "No image selected"}
                    disabled
                    readOnly
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      background: "none",
                    }}
                  />
                </div>

                {uploading && (
                  <p style={{ fontSize: "13px", marginTop: "4px" }}>
                    Uploading... {uploadProgress}%
                  </p>
                )}

                {errors.image && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.image.message}
                  </span>
                )}
              </div>
            </div>

            <Col md="6">
              <Controller
                name="type"
                control={control}
                defaultValue={null}
                rules={{ required: "type is required" }}
                render={({ field }) => (
                  <CustomSelect
                    label="Type"
                    name="type"
                    options={blogType}
                    field={field}
                    customLabel=""
                    errors={errors.blogType}
                  />
                )}
              />
            </Col>

            <Col md="12">
  <label className="input_lable">Content</label>
  <Controller
    name="content"
    control={control}
    defaultValue=""
    rules={{ required: "Content is required" }}
    render={({ field }) => (
      <ReactQuill
        theme="snow"
        value={field.value}
        onChange={field.onChange}
        placeholder="Write your content here..."
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
          ],
        }}
        formats={[
          "header",
          "bold", "italic", "underline", "strike", "blockquote",
          "list", "bullet",
          "link", "image"
        ]}
      />
    )}
  />
  {errors.content && (
    <span style={{ color: "red", fontSize: "14px" }}>
      {errors.content.message}
    </span>
  )}
</Col>

          </Row>
          <button
            className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
          >
            Submit
          </button>
        </form>
      </CustomPopup>
    </>
  );
};

export default Blog;
